export default {
        ticketId: "",
        raisedby: "",
        description: "",
        attachmentId: "",
        status: "",
        createddate: "",
        taskassginedon: "",
        closedon: "",
        lastmodifieddate: "",
        notes:"",
        history: {
            createdBy:"",
            date:"",
            newstatus:"",
            notes: "",
            previousstatus: "",
            ticket_id:""
        }
    }
    

